// Various utility functions, some created by PW and some brought in from the intertubes (all open source)
// Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams

/** Checks whether a value is empty, defined as null or undefined or "".
 *  Note that 0 is defined as not empty.
 *  @param {*} val - value to check
 *  @returns {boolean}
 */
window.empty = function(val) {
	// you can also call this fn as empty(o, 'foo', 'bar'), which will return true if:
	// - o is empty OR o is not an object
	// - o.foo is empty OR o.foo is not an object
	// - o.foo.bar is empty OR o.foo.bar is not an object
	// this simplifies an if clause like `if (empty(o) || empty(o.foo) || empty(o.foo.bar))` to `if (empty(o, 'foo', 'bar'))`
	if (arguments.length > 1) {
		if (empty(val) || typeof(val) != 'object') {
			return true
		}

		// if we get to here, arguments[1] might be an array or the first of a series of strings; handle both cases
		let args
		if ($.isArray(arguments[1])) {
			args = arguments[1]
		} else {
			// copy arguments, then use splice to get everything from index 1 on
			args = $.merge([], arguments).splice(1)
		}

		// if we're here, we know that val is itself an object
		if (empty(val[args[0]])) {
			return true
		} else if (args.length > 1) {
			// shift the first value out of args and recurse
			val = val[args[0]]
			args.shift()
			return empty(val, args)
		}
		return false
	}

	// note that we need === because (0 == "") evaluates to true
	return (val === null || val === "" || val === undefined)
}


/** Return val or default_val, depending on whether val isn't or is empty (as defined by window.empty above)
 *  SHORTCUT: dv()
 */
window.default_value = function(val, default_val) {
	if (!empty(val)) return val
	return default_val
}
window.dv = window.default_value

/** Set a property of an object to a default value if the property is currently empty (as defined by window.empty above)
 *  SHORTCUT: sdp()
 *  Two versions:
 *      1. sdp(o, 'foo', 'bar')
 *          - sets o.foo to 'bar', unless o.foo is already set
 *      2. sdp(o, p, 'foo', 'bar')
 *          - if p.foo is set, then set o.foo to p.foo; otherwise set o.foo to 'bar'
 *
 *  Also do some limited type checking: if default_val is a Boolean or a number, make sure the value we ultimately set
 *      is a Boolean or number; if converting it to the correct type fails, throw an error
 */
window.set_default_property = function(o, prop, default_val) {
	var val
	if (arguments.length == 4) {
		default_val = arguments[3]
		prop = arguments[2]
		var p = arguments[1]
		if (!empty(p) && !empty(p[prop])) val = p[prop]
		else val = default_val
	} else {
		if (!empty(o[prop])) val = o[prop]
		else val = default_val
	}

	// if default_val is true or false, make sure the value we set is also a boolean
	if (default_val === true || default_val === false) {
		if (val === 'true') val = true
		if (val === 'false') val = false
		if (val != true && val != false) {
			if (typeof(prop) == 'object') prop = '[object]'
			throw new Error(sr('Boolean argument expected for property $1; $2 received', prop, val))
		}

	// if default_val is a number, make sure the value we set is also a number
	} else if (typeof(default_val) == 'number') {
		let new_val = val * 1
		if (isNaN(val)) {
			throw new Error(sr('Numeric argument expected for property $1; $2 received', prop, val))
		}
		val = new_val
	}

	o[prop] = val
}
window.sdp = window.set_default_property

/** Replace variables in a string, a la PHP
 * e.g.:
 * str_replace("replace value $bar.", {bar: "foo"})
 *    =>
 * "replace value foo."
 *
 * o.bar can be either a scalar value or a function that returns a scalar value
 *
 * Or, you can pass variables in directly, and specify them with $1, $2, $3, etc.
 * str_replace("replace value $1.", "foo")
 *    =>
 * "replace value foo."
 *
 * SHORTCUT: sr()
 *
 *  @param {string} s
 *  @param {object|array} [o] - if this is an array, it will be assumed to be an array of objects. if this is not an array or an object, it will treat the arguments array as a list of scalars
 *  @returns {*}
 */
window.str_replace = function(s, o) {
	// if o is an array, recursively process each object in the array
	if ($.isArray(o)) {
		for (var i = 0; i < o.length; ++i) {
			s = str_replace(s, o[i])
		}

	} if (typeof(o) == "object") {
		// find all instances of $xxx
		var matches = s.match(/\$(\w+)\b/g)
		if (!empty(matches)) {
			for (var i = 0; i < matches.length; ++i) {
				var key = matches[i].substr(1)
				var val = null
				// scalars
				if (typeof(o[key]) == "string" || typeof(o[key]) == "number") {
					val = o[key]
				} else if (typeof(o[key]) == "function") {
					val = o[key]()
				}
				if (val !== null) {
					var re = new RegExp("\\$" + key + "\\b", "g")
					s = s.replace(re, val)
				}
			}
		}
	} else {
		for (var i = 1; i < arguments.length; ++i) {
			var re = new RegExp("\\$" + i + "\\b", "g")
			s = s.replace(re, arguments[i])
		}
	}
	return s
}
// shortcut
window.sr = str_replace

window.U = {}

// universal user info model for all apps
U.user_info = {}
U.set_user_info = function(payload) {
	sdp(U.user_info, payload, 'user_id', 0)
	sdp(U.user_info, payload, 'user_key', '')
	sdp(U.user_info, payload, 'displayname', '')
	sdp(U.user_info, payload, 'email', '')
	sdp(U.user_info, payload, 'role', 0)
}
U.user_is_instructor = function() {
	return U.user_info.role >= 1000
}
// use !U.user_is_instructor() to identify students

// try to get PHPSESSID
U.session_id = ''
if (window.location.search.search(/.*PHPSESSID=(\w+).*/) > -1) {
	U.session_id = RegExp.$1
}

U.ajax = function(service_name, data, callback_fn, override_options) {
	// create url with Tsugi PHPSESSID, and add service_name to data
	var url
	// local development with 'npm run serve'
	if (document.location.host.indexOf('localhost') > -1) {
        // url = "/src/ajax.php"
        url = "/ajax.php"
        // url = "/~bmosbacker/guid_translator/src/ajax.php"
	// server, or local testing with 'npm run build'
	} else {
		// url = "/src/ajax.php"
		url = "/ajax.php"
		// url = "/~bmosbacker/guid_translator/src/ajax.php"
	}
	if (!empty(U.session_id)) url += "?PHPSESSID=" + U.session_id

	data.service_name = service_name

	var options = {
		type: "POST",
		url: url,
		cache: false,
		data: data,
		dataType: "text",
		success: function(str, text_status) {
			var result
			if (empty(str)) {
				result = {"status": "Ajax returned with no status"}
			} else {
				try {
					result = JSON.parse(str)
				} catch(e) {
					result = {"status": str}
				}
			}

			if (empty(result.status)) {
				result.status = "Ajax returned with no status"
			}
			if (result.status != "ok") {
				// error
				console.log("ajax success but not 'ok'", result)
			}

			if (!empty(callback_fn)) {
				callback_fn(result)
			}

		},
		error: function(jqXHR, textStatus, errorThrown) {
			if (jqXHR.responseText == 'Session expired - please re-launch') {
				alert('Your session has expired.')
				// TODO: figure out what we want to do here...
			}

			var result = {
				"status": "Ajax server error",
				"ajax_name": service_name,
				"textStatus": textStatus,
				"errorThrown": errorThrown,
				"responseText": jqXHR.responseText
			}

			if (!empty(callback_fn)) {
				callback_fn(result)
			}
		}
	}

	// override any options coming in
	if (!empty(override_options)) {
		for (var key in override_options) {
			options[key] = override_options[key]
		}
	}

	$.ajax(options)
}

U.loading_start = function(msg) {
	$('#spinner-wrapper').show()
	if (!empty(msg)) {
		$('#spinner-wrapper').append(sr('<div id="spinner-wrapper-msg" style="text-align:center;margin:20% 30px 0 30px;font-size:24px;font-weight:bold;font-family:sans-serif;color:#fff;">$1</div>', msg))
	}
}

U.loading_stop = function() {
	$('#spinner-wrapper').hide()
	$('#spinner-wrapper-msg').remove()
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 * https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
 */
U.shuffle_array = function(array) {
	for (var i = array.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
}

// if one argument is specified, it's max and we return >= 0  and < max (use for an array index, e.g.)
// if two arguments are specified, they're min and max, and we return >= min and <= max
// if the first argument is a function, assume it's a random number generator to use instead of Math.random()
U.random_int = function() {
	let rng = Math.random
    let args
	if (arguments.length > 0 && typeof(arguments[0]) == "function") {
		rng = arguments[0]
        args = [arguments[1], arguments[2]]
	} else {
        args = arguments
    }

	if (empty(args[0])) return 0

	let min, max
	if (empty(args[1])) {
		min = 0
		max = args[0] * 1
	} else {
		min = args[0] * 1
		max = args[1] * 1 + 1
	}
	if (isNaN(min) || isNaN(max)) {
		return 0
	}
	return min + Math.floor(rng() * (max-min))
}

U.word_count = function(text) {
	if (empty(text)) return 0
	text = '' + text

	// remove entities
	text = text.replace(/\&[#\w]+/g, ' ')

	// insert spaces at breaks
	text = text.replace(/\b/g, ' ')

	// remove tags
	text = text.replace(/<.*?>/g, ' ')

	// remove non-letters
	text = text.replace(/[^\w\s]/g, '')

	// trim
	text = $.trim(text)

	// split on spaces and return count
	let arr = text.split(/\s+/)
	return arr.length;
}

// plural string / plural string with number
// ps('word', 1) => 'word'
// ps('word', 2) => 'words'
// psn('word', 2) => '2 words'
// ps('a word', 2, 'the words') => 'the words'
U.ps = function(s, val, plural_s) {
	if (val*1 == 1) return s
	if (!empty(plural_s)) return plural_s
	return s + 's'
}
U.psn = function(s, val, plural_s) {
	s = U.ps(s, val, plural_s)
	return sr('$1 $2', val, s)
}

U.capitalize_word = function(s) {
	if (empty(s) || typeof(s) != 'string') return ''
	return s[0].toUpperCase() + s.substr(1)
}

// formats seconds into "hh:mm:ss", with leading zeros inserted as appropriate and hours optional
U.time_string = function(seconds) {
	seconds = Math.round(seconds)
	let hours = Math.floor(seconds / 3600)
	let minutes = Math.floor((seconds - hours*3600) / 60)
	seconds = seconds % 60
	if (seconds < 10) seconds = '0' + seconds
	let ts = sr('$1:$2', minutes, seconds)
	if (hours > 0) {
		if (minutes < 10) ts = '0' + ts
		ts = sr('$1:$2', hours, ts)
	}

	return ts
}

// generates RFC-compliant GUIDs
// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
// this is "e7" of Jeff Ward's answer
U.guid_lut = []; for (var i=0; i<256; i++) { U.guid_lut[i] = (i<16?'0':'')+(i).toString(16); }
U.new_uuid = function() {
	var d0 = Math.random()*0xffffffff|0;
	var d1 = Math.random()*0xffffffff|0;
	var d2 = Math.random()*0xffffffff|0;
	var d3 = Math.random()*0xffffffff|0;
	return U.guid_lut[d0&0xff]+U.guid_lut[d0>>8&0xff]+U.guid_lut[d0>>16&0xff]+U.guid_lut[d0>>24&0xff]+'-'+
		U.guid_lut[d1&0xff]+U.guid_lut[d1>>8&0xff]+'-'+U.guid_lut[d1>>16&0x0f|0x40]+U.guid_lut[d1>>24&0xff]+'-'+
		U.guid_lut[d2&0x3f|0x80]+U.guid_lut[d2>>8&0xff]+'-'+U.guid_lut[d2>>16&0xff]+U.guid_lut[d2>>24&0xff]+
		U.guid_lut[d3&0xff]+U.guid_lut[d3>>8&0xff]+U.guid_lut[d3>>16&0xff]+U.guid_lut[d3>>24&0xff];
}

U.is_letter = function(char) {
	return ('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(char) > -1)
}

// Sound effects, using howler
// https://medium.com/game-development-stuff/how-to-create-audiosprites-to-use-with-howler-js-beed5d006ac1
U.sounds = {
	sprite: {
	  "complete_blank": [
		0,
		2953.378684807256
	  ],
	  "complete_exercise": [
		4000,
		1819.0249433106578
	  ],
	  "pop_1": [	// correct guess
		7000,
		996.8934240362817
	  ],
	  "pop_2": [	// incorrect guess
		9000,
		996.8934240362817
	  ],
	  "pop_3": [	// hint
		11000,
		996.8934240362817
	  ],
	  "pop_4": [
		13000,
		748.9569160997736
	  ],
	  "pop_click": [	// open blank
		15000,
		480.7709750566893
	  ]
	},

	// U.sounds.on = false // turn off sound effects
	on: true
}

U.sounds.initialize = function() {
	if (U.sounds.loaded === true) return

	// delay so nothing else will wait for sound initialization to finish
	setTimeout(()=>{
		U.sounds.howl = new Howl({
			src: ['/audio/sparklsounds.ogg', '/audio/sparklsounds.mp3'],
			volume: 0.1,
			sprite: U.sounds.sprite,
		})

		U.sounds.howl.once('load', ()=>{
			U.sounds.loaded = true
			console.log('sounds loaded!')
		})
	}, 0)
}

U.sounds.play = function(id) {
	if (!U.sounds.loaded || !U.sounds.on) return

	if (empty(U.sounds.sprite[id])) {
		console.log(sr('Tried to play nonexistant sound effect “$1”', id))
	} else {
		U.sounds.howl.play(id)
	}
}

// utilities for using local storage to save and retrieve settings
U.local_storage_set = function(key, val) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	window.localStorage.setItem(key, JSON.stringify(val));
}

U.local_storage_clear = function(key) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	window.localStorage.removeItem(key);
}

U.local_storage_get = function(key, default_val) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	let val = window.localStorage.getItem(key)
	if (!empty(val)) val = JSON.parse(val);

	if (empty(val)) {
		return default_val
	} else {
		// do some type checking
		if (default_val === true || default_val === false) {
			if (val === 'true') val = true
			if (val === 'false') val = false
			if (val != true && val != false) {
				throw new Error(sr('Boolean argument expected for key $1; $2 received', key, val))
			}

		} else if (typeof(default_val) == 'number') {
			if (isNaN(val*1)) {
				throw new Error(sr('Numeric argument expected for key $1; $2 received', key, val))
			}
			val = val * 1

		} else if (typeof(default_val) == 'string') {
			if (typeof(val) != 'string') {
				throw new Error(sr('String argument expected for key $1; $2 received', key, val))
			}
			val = val + ''
		}
		return val
	}
}

U.cookie_set = function(key, val) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	document.cookie = sr('$1=$2', key, val)
}

U.cookie_clear = function(key) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
}

U.cookie_get = function(key, default_val) {
	// use a consistent prefix for every key
	key = 'pwet__' + key

	let cookies = document.cookie.split(';')
	for (let c of cookies) {
		let arr = c.split('=')
		if ($.trim(arr[0]) == key) {
			let val = arr[1]
			// do some type checking
			if (default_val === true || default_val === false) {
				if (val === 'true') val = true
				if (val === 'false') val = false
				if (val != true && val != false) {
					throw new Error(sr('Boolean argument expected for key $1; $2 received', key, val))
				}

			} else if (typeof(default_val) == 'number') {
				if (isNaN(val*1)) {
					throw new Error(sr('Numeric argument expected for key $1; $2 received', key, val))
				}
				val = val * 1

			} else if (typeof(default_val) == 'string') {
				if (typeof(val) != 'string') {
					throw new Error(sr('String argument expected for key $1; $2 received', key, val))
				}
				val = val + ''
			}
			return val
		}
	}
}

// normalize strings for response validation
U.normalize_string_for_validation = function(s) {
	if (empty(s)) return ''

	// remove html
	s = s.replace(/<[\w|\/].*?>/g, ' ')

	// remove entities
	s = s.replace(/\&\w+;/g, ' ');

	// normalize single-quotes and remove single-quotes that aren't contractions
	s = s.replace(/[‘’]/g, "'")
	s = s.replace(/'\s/g, ' ')
	s = s.replace(/\s'/g, ' ')

	// remove all chars except letters, numbers, and basic punctuation (see list in regex) (?)
	s = s.replace(/[^\w'().,;:?!]/g, ' ')

	// collapse multiple spaces and trim
	s = $.trim(s.replace(/\s+/g, ' '))

	// use lower case for everything (?)
	s = s.toLowerCase()
	return s
}

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not be triggered.
// The function will be called after it stops being called for N milliseconds.
// If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
// To call:
	// // establish the debounce fn if necessary
	// if (empty(this.fn_debounced)) {
	// 	this.fn_debounced = U.debounce(function(x) {
	// 		...
	// 	}, 1000)
	// }
	// // call the debounce fn
	// this.fn_debounced(x)
U.debounce = function(func, wait, immediate) {
  	var timeout

  	// This is the function that is actually executed when the DOM event is triggered.
  	return function executedFunction() {
    	// Store the context of this and any parameters passed to executedFunction
    	var context = this
    	var args = arguments

    	// The function to be called after the debounce time has elapsed
    	var later = function() {
      		// null timeout to indicate the debounce ended
      		timeout = null

      		// Call function now if you did not on the leading end
      		if (!immediate) func.apply(context, args)
    	}

    	// Determine if you should call the function on the leading or trail end
    	var callNow = immediate && !timeout

    	// This will reset the waiting every function execution. This is the step that prevents the function
    	// from being executed because it will never reach the inside of the previous setTimeout
    	clearTimeout(timeout)

    	// Restart the debounce waiting period. setTimeout returns a truthy value (it differs in web vs node)
    	timeout = setTimeout(later, wait)

    	// Call immediately if you're dong a leading end execution
    	if (callNow) func.apply(context, args)
  	}
}

// apply a shake animation to the given element (specified as jquery)
// dir is 'h' or 'v'; add an id if multiple things are likely to be shaken in quick succession; otherwise the clearTimeouts will conflict
U.shake = function(jq, dir, id) {
	if (empty(id)) id = 'x'

	// clear previous timeout if found
	if (!empty(U['shake_timeout_' + id])) clearTimeout(U['shake_timeout_' + id])

	// add shake class
	jq.addClass('k-shake-' + dir)

	// remove class after delay for shake
	U['shake_timeout_' + id] = setTimeout(x=>jq.removeClass('k-shake-' + dir), 600)
}

/*
seedrandom

// Make a predictable pseudorandom number generator.
var myrng = new Math.seedrandom('hello.');
console.log(myrng());                // Always 0.9282578795792454
console.log(myrng());                // Always 0.3752569768646784
*/
!function(f,a,c){var s,l=256,p="random",d=c.pow(l,6),g=c.pow(2,52),y=2*g,h=l-1;function n(n,t,r){function e(){for(var n=u.g(6),t=d,r=0;n<g;)n=(n+r)*l,t*=l,r=u.g(1);for(;y<=n;)n/=2,t/=2,r>>>=1;return(n+r)/t}var o=[],i=j(function n(t,r){var e,o=[],i=typeof t;if(r&&"object"==i)for(e in t)try{o.push(n(t[e],r-1))}catch(n){}return o.length?o:"string"==i?t:t+"\0"}((t=1==t?{entropy:!0}:t||{}).entropy?[n,S(a)]:null==n?function(){try{var n;return s&&(n=s.randomBytes)?n=n(l):(n=new Uint8Array(l),(f.crypto||f.msCrypto).getRandomValues(n)),S(n)}catch(n){var t=f.navigator,r=t&&t.plugins;return[+new Date,f,r,f.screen,S(a)]}}():n,3),o),u=new m(o);return e.int32=function(){return 0|u.g(4)},e.quick=function(){return u.g(4)/4294967296},e.double=e,j(S(u.S),a),(t.pass||r||function(n,t,r,e){return e&&(e.S&&v(e,u),n.state=function(){return v(u,{})}),r?(c[p]=n,t):n})(e,i,"global"in t?t.global:this==c,t.state)}function m(n){var t,r=n.length,u=this,e=0,o=u.i=u.j=0,i=u.S=[];for(r||(n=[r++]);e<l;)i[e]=e++;for(e=0;e<l;e++)i[e]=i[o=h&o+n[e%r]+(t=i[e])],i[o]=t;(u.g=function(n){for(var t,r=0,e=u.i,o=u.j,i=u.S;n--;)t=i[e=h&e+1],r=r*l+i[h&(i[e]=i[o=h&o+t])+(i[o]=t)];return u.i=e,u.j=o,r})(l)}function v(n,t){return t.i=n.i,t.j=n.j,t.S=n.S.slice(),t}function j(n,t){for(var r,e=n+"",o=0;o<e.length;)t[h&o]=h&(r^=19*t[h&o])+e.charCodeAt(o++);return S(t)}function S(n){return String.fromCharCode.apply(0,n)}if(j(c.random(),a),"object"==typeof module&&module.exports){module.exports=n;try{s=require("crypto")}catch(n){}}else"function"==typeof define&&define.amd?define(function(){return n}):c["seed"+p]=n}("undefined"!=typeof self?self:this,[],Math);

// https://stackoverflow.com/questions/1293147/javascript-code-to-parse-csv-data
window.CSV = {
	parse: function(csv, reviver) {
	    reviver = reviver || function(r, c, v) { return v; };
	    var chars = csv.split(''), c = 0, cc = chars.length, start, end, table = [], row;
	    while (c < cc) {
	        table.push(row = []);
	        while (c < cc && '\r' !== chars[c] && '\n' !== chars[c]) {
	            start = end = c;
	            if ('"' === chars[c]){
	                start = end = ++c;
	                while (c < cc) {
	                    if ('"' === chars[c]) {
	                        if ('"' !== chars[c+1]) { break; }
	                        else { chars[++c] = ''; } // unescape ""
	                    }
	                    end = ++c;
	                }
	                if ('"' === chars[c]) { ++c; }
	                while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) { ++c; }
	            } else {
	                while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) { end = ++c; }
	            }
	            row.push(reviver(table.length-1, row.length, chars.slice(start, end).join('')));
	            if (',' === chars[c]) { ++c; }
	        }
	        if ('\r' === chars[c]) { ++c; }
	        if ('\n' === chars[c]) { ++c; }
	    }
	    return table;
	},

	stringify: function(table, replacer) {
	    replacer = replacer || function(r, c, v) { return v; };
	    var csv = '', c, cc, r, rr = table.length, cell;
	    for (r = 0; r < rr; ++r) {
	        if (r) { csv += '\r\n'; }
	        for (c = 0, cc = table[r].length; c < cc; ++c) {
	            if (c) { csv += ','; }
	            cell = replacer(r, c, table[r][c]);
	            if (/[,\r\n"]/.test(cell)) { cell = '"' + cell.replace(/"/g, '""') + '"'; }
	            csv += (cell || 0 === cell) ? cell : '';
	        }
	    }
	    return csv;
	}
};

// simple TSV equivalent to CSV fns above
window.TSV = {
	parse: function(tsv) {
		let lines = tsv.split('\n')
		for (let i = 0; i < lines.length; ++i) {
			let line = $.trim(lines[i])

			if (empty(line)) {
				lines[i] = []
			} else {
				lines[i] = line.split('\t')
			}
		}
		return lines
	},

	stringify:function(lines) {
		let tsv = ''
		for (let i = 0; i < lines.length; ++i) {
			tsv += lines[i].join('\t') + '\n'
		}
		return tsv
	}
};

/*
date and time functions:
npm i date-and-time
https://github.com/knowledgecode/date-and-time

in main.js:
import date from 'date-and-time'
import 'date-and-time/plugin/meridiem';
date.plugin('meridiem')
window.date = date

to convert from timestamp:
date.format(new Date(this.entry.date_added*1000), 'MMMM D, YYYY h:mm AA')	// January 1, 2019 3:12 PM

to convert from mysql date to js Date, then to an alternate format:
let d = date.parse(data.results.created_at, 'YYYY-MM-DD HH:mm:ss')
date.format(d, 'MMM D, YYYY h:mm A')	// Jan 3, 2020 3:04 PM

token   meaning	  example
YYYY    year      0999, 2015
YY      year      05, 99
Y       year      2, 44, 888, 2015
MMMM    month     January, December
MMM     month     Jan, Dec
MM      month     01, 12
M       month     1, 12
DDD (*) day       1st, 2nd, 3rd
DD      day       02, 31
D       day       2, 31
dddd    day/week  Friday, Sunday
ddd     day/week  Fri, Sun
dd      day/week  Fr, Su
HH      24-hour   23, 08
H       24-hour   23, 8
A       meridiem  AM, PM
a (*)   meridiem  am, pm
AA (*)  meridiem  A.M., P.M.
aa (*)  meridiem  a.m., p.m.
hh      12-hour   11, 08
h       12-hour   11, 8
mm      minute    14, 07
m       minute    14, 7
ss      second    05, 10
s       second    5, 10
SSS     msec      753, 022
SS      msec      75, 02
S       msec      7, 0
Z       timezone  +0100, -0800
*/
